import { AvailableModules } from 'generated/featureDefinitions'

import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'
import type { ModuleAvailabilityType } from 'modules/core/hooks/useModuleAvailability'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

import atsCompanies from 'modules/ats/store/collections/atsCompanies'

export const checkAtsEnabled = (moduleAvailabilities: ModuleAvailabilityType[]) => {
  return isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.ats)
}

export const useAtsEnabled = () => {
  const { moduleAvailabilities, loading } = useModuleAvailabilities()

  return {
    atsEnabled: isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.ats),
    loading,
  }
}

export const useOpenPositionsEnabled = () => {
  const { atsEnabled } = useAtsEnabled()
  const hasReferralsEnabled = atsCompanies.current?.attributes.referrals_enabled
  return atsEnabled && hasReferralsEnabled
}
